import React, { Component } from 'react'

import LabelWrapper from '../labelWrapper'
import Icon from '../icon'

import { ElementIcons } from '../icons'

import './text.scss'
// import '../elements.scss'

class Text extends Component {

  constructor (props) {
    super(props)
    this.state = {
      showHint: false
    }
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.showIcon = true
  }

  onChange (e) {
    // console.log('Text onChange triggered! ', e)
    if (this.props.onChange !== null) {
      this.showIcon = false
      this.props.onChange(e)
    }
  }

  onBlur (e) {
    // console.log('Text onBlur triggered! ', e)
    if (this.props.onBlur !== null) {
      this.showIcon = true
      this.props.onBlur(e)
    }
  }

  onFocus (e) {
    // console.log('Text onFocus triggered!', e)
    if (this.props.onFocus !== null) {
      this.props.onFocus(e)
    }
  }

  onKeyDown (e) {
    // console.log('Text onKeyDown triggered!', e)
    if (this.props.onKeyDown !== null) {
      this.props.onKeyDown(e)
    }
  }

  onKeyPress (e) {
    // console.log('Text onKeyPress triggered!', e)
    if (this.props.onKeyPress !== null) {
      this.props.onKeyPress(e)
    }
  }

  onClick (e) {
    // console.log('Text onClick triggered!', e)
    if (this.props.onClick !== null) {
      this.props.onClick(e)
    }
  }

  getSizeClass () {
    switch (this.props.size) {
      case undefined:
      case null:
      case 'l':
        return 'size-large'
      case 'm':
        return 'size-medium'
      case 's':
        return 'size-small'
    }
  }

  getIconSize () {
    switch (this.props.size) {
      case undefined:
      case null:
      case 's':
      case 'm':
        return 't'
      case 'l':
        return 's'
    }
  }

  getIconClass () {
    let iconClass = (this.props.showValidationIcon && this.showIcon) ? 'text-success' : ''
    return iconClass
  }

  getCustomClass () {
    return this.props.className
  }

  getSolidClass () {
    return ''
  }

  getBorderClass () {
    return this.props.redBorder ? ' red-border' : ''
  }

  getStyle () {
    return 'element-text' + this.getSolidClass() + this.getBorderClass()
  }

  render () {
    const renderInput = () => {
      return [
        <input
          ref={'input'}
          className={this.getSizeClass() + this.getBorderClass() + ' ' + this.getCustomClass()}
          type={this.props.isPassword ? 'password' : 'text'}
          id={this.props.id}
          name={this.props.name}
          value={this.props.value}
          onChange={this.onChange.bind(this)}
          onBlur={this.onBlur.bind(this)}
          onFocus={this.onFocus.bind(this)}
          onKeyDown={this.onKeyDown.bind(this)}
          onKeyPress={this.onKeyPress.bind(this)}
          onClick={this.onClick.bind(this)}
          readOnly={this.props.readOnly}
          required={this.props.required}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
          defaultValue={this.props.defaultValue}
          maxLength={this.props.maxLength}
          autoComplete={this.props.autoComplete}
          key={'text'}
        />,
        this.props.showValidationIcon && this.showIcon && <Icon key={'icon'} icon={ElementIcons.Text_Success} className={this.getIconClass()} size={this.getIconSize()} injectSvg />
      ]
    }

    const renderWrapper = (content) => {
      return (
        <LabelWrapper
          labelText={this.props.labelText}
          hintText={this.props.hintText}
          helpText={this.props.helpText}
          errorText={this.props.errorText}
          for={this.props.id}
        >
          {content}
        </LabelWrapper>
      )
    }

    return (
      <div className={this.getStyle()}>
        {(!this.props.simple && this.props.labelText !== null) ? renderWrapper(renderInput()) : renderInput()}
      </div>
    )
  }
}

Text.defaultProps = {
  size: 'l',
  style: 'default',
  labelText: null,
  hintText: null,
  helpText: null,
  onChange: null,
  onKeyDown: null,
  onKeyPress: null,
  onBlur: null,
  onFocus: null,
  onClick: null,
  readOnly: false,
  required: false,
  // value: '', // For defaultValue to work, this must be able to be undefined
  placeholder: '',
  errorText: null,
  disabled: false,
  maxLength: null,
  isPassword: false,
  autoComplete: null,
  simple: false,
  className: '',
  showValidationIcon: false,
  redBorder: false
}

export default Text



// WEBPACK FOOTER //
// ./src/app/shared/elements/text/index.js